//
//
//
//
//
//
//

export default {
  name: 'UiBetslipButton',
  props: {
    value: {
      required: false,
      default: null
    }
  }
}
